import { render } from "./FlushMessage.vue?vue&type=template&id=c072c1ce&scoped=true"
import script from "./FlushMessage.vue?vue&type=script&lang=js"
export * from "./FlushMessage.vue?vue&type=script&lang=js"

import "./FlushMessage.vue?vue&type=style&index=0&id=c072c1ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c072c1ce"]])

export default __exports__